import { render, staticRenderFns } from "./deductList.vue?vue&type=template&id=51f7382b&scoped=true"
import script from "./deductList.vue?vue&type=script&lang=js"
export * from "./deductList.vue?vue&type=script&lang=js"
import style0 from "./deductList.vue?vue&type=style&index=0&id=51f7382b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f7382b",
  null
  
)

export default component.exports